export default from './CarouselModal'


// WEBPACK FOOTER //
// ./src/components/CarouselModal/index.js